import { ComponentType } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useTranslate } from '../hooks/context/useTranslate';
import PageContent from '../layouts/PageContent/PageContent';

// Logged-in route wrapper — Header + Sidebar come from the persistent shell (AppShell).
const withPageContent = <P extends RouteComponentProps>(
  Component: ComponentType<P>
) => {
  const WithPageContentWrapper = (props: P) => {
    const { isLoading: isTranslationLoading } = useTranslate();

    return (
      <PageContent isLoading={isTranslationLoading}>
        <Component {...props} />
      </PageContent>
    );
  };

  return WithPageContentWrapper;
};

export default withPageContent;
